import React from 'react';
import Navigation from '../components/Navigation';
import Collection from '../components/Collection';

const Gallery = () => {
    return (
        <div>
            <Navigation />
            <Collection />
        </div>
    );
};

export default Gallery;